module.exports = __webpack_public_path__ + "static/media/1.2f937402.jpg";